componentRegistryInstance.register('table', 'read', 'hrd.components.form.TableComponent');

hrd.components.form.TableComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.TableComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	reEnhanceReadField: function(field, id) {
		this.enhanceReadFieldInner(field, id);
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, 'table-container');
		this.enhanceReadFieldInner(field, id);
	},
	enhanceReadFieldInner: function(field, id) {
		let $composite = this.getFieldComposite(field);
		let $label = field.prev('label');
		$composite.addClass('skip-layout');
		let ignoreLabelOnTop = field.data('ignoreLabelOnTop') === true;
		if (!ignoreLabelOnTop) {
			$composite.addClass('label-on-top');
			$label.addClass('ignore-aw');
		}

		let reference = this.settings.reference;
		let tableManager = field.data('manager'); // can be reused if in a dialog

		if (tableManager == undefined) {
			let tmOptions = {
				insideDashlet: false,
				reference: reference
			};
			tableManager = new hrd.manager.TableManager(field, tmOptions);
			field.data('manager', tableManager);
		}

		let tablePromise = tableManager.doTable().then((tableInstance) => $.when(tableInstance));

		this.addEnhancePhasePromise(tablePromise);
	},
	getReadOnlyField: function(field, name, object, options) {
		let tableManager = field.data('manager');
		if (tableManager != undefined && name != undefined) {
			let selection = tableManager.getSelectedData();
			this.setValueByPath(object, name, selection);
		}
	},
	setReadOnlyField: function(field, value, object, options) {
		let tableManager = field.data('manager');
		let name = this.getFieldName();
		if (tableManager != undefined && !options.skipUpdateTable) {
			var hideWhen = field.data('hideWhen');
			var formObject = object || {};
			var hideTable = hideWhen ? $.evaluate(hideWhen, this.settings.reference, [formObject], ['formObject']) : false;

			if (hideTable == true) {
				this.hideField(field);
			} else {
				this.showField(field);
				if (!!$(field).data('set-indexes')) {
					const values = $.extend([], value) || [];
					if (values && values.length > 0) {
						let indexes = values.map((obj) => {
							let cbId = (obj.codice) ? obj.codice : obj.id;
							return cbId;
						});
						tableManager.selectedIndexes = indexes;
						tableManager.selectedObjects = values;
					}
				}
				tableManager.refreshTable()
					.then(() => {
						if (!!$(field).data('prefill-selection')) {
							if ($(`input[type="checkbox"][name="${name}-row-id"]`, tableManager.settings.tableId).exists()) {
								const values = $.extend([], value) || [];
								if (values && values.length > 0) {
									values.forEach((obj) => {
										if (obj) {
											let cbId = (obj.codice) ? obj.codice : obj.id;
											let $input = $(`input[type="checkbox"][name="${name}-row-id"][value="${cbId}"]`, tableManager.settings.tableId);
											if (!$input.prop('checked')) {
												$input.trigger('click');
											}
										}
									});
								}
							}
						}
					});
			}
		}
	},
	resetReadOnlyField: function(field, options) {
		let tableManager = field.data('manager');
		if (tableManager != undefined) {
			if(options.resetSelectionOnly) {
				tableManager.clearSelectedIndexes();
				tableManager.clearFilters(false);
				tableManager.clearRowActive();
			} else if(!options.skipResetTable) {
				tableManager.clearSelectedIndexes();
				tableManager.clearFilters(false);
				tableManager.clearRowActive();
				tableManager.clearTable(false);
			}
		}
	}
});